import { styled } from 'src/styles/stitches.config'

export const StyledPost = styled('div', {
    marginBottom: '$md',
    '@md': {
        marginBottom: 0,
        width: 'calc(6 * $colWidth)',
    },
})
